import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
  tooltip: {
    fontSize: 13,
    fontWeight: 300,
    backgroundColor: '#313131',
    padding: theme.spacing(1.5, 2),
  },
  arrow: {
    color: '#313131',
  },
}))

function Tooltip(props) {
  const { title, children } = props;
  const classes = useStyles();
  return (
    title === undefined || title === null ? 
      children : (
        <MuiTooltip 
          arrow 
          {...props}
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}
        />
      )
  );
}

Tooltip.propTypes = {
  /** Tooltip content */
  title: PropTypes.node,
  /** Children to display */
  children: PropTypes.any,
};
export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.jsx